import { all } from 'redux-saga/effects';
import { actWatchDlUnit } from './dlUnit';
import { actWatchAdmDlUnit } from './adm/admDlUnit';
import { actWatchDlGroup } from './dlGroup';
import { actWatchAdmDlGroup } from './adm/admDlGroup';
import { actWatchPhotoSer } from './photoSer';
import { actWatchAdmPhotoSer } from './adm/admPhotoSer';
import { actWatchUser } from './user';
import { actWatchAdmUser } from './adm/admUser';
import { actWatchAdmAuth } from './adm/admAuth';

export function* rootSaga() {
    yield all([
        actWatchDlUnit(),
        actWatchAdmDlUnit(),
        actWatchDlGroup(),
        actWatchAdmDlGroup(),
        actWatchPhotoSer(),
        actWatchAdmPhotoSer(),
        actWatchUser(),
        actWatchAdmUser(),
        actWatchAdmAuth(),
    ]);
}